import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subsidiary-contract',
  templateUrl: './subsidiary-contract.component.html',
  styleUrls: ['./subsidiary-contract.component.css']
})
export class SubsidiaryContractComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
